module.exports = __webpack_public_path__ + "img/swiper-1.d4aaeb1d.png";